import './App.css'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import MarkerClusterGroup from 'react-leaflet-cluster'
import L from 'leaflet'
import 'leaflet-easybutton/src/easy-button.js'
import 'leaflet-easybutton/src/easy-button.css'
import filterIcon from './images/filter.png'
import emailIcon from './images/email.png'
import internetIcon from './images/internet.png'
import yesIcon from './images/yes.png'
import noIcon from './images/no.png'
import { useEffect, useState, Fragment } from 'react'
import Control from 'react-leaflet-custom-control'
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, Modal, Box, Select, MenuItem, Checkbox, Typography, FormControl, OutlinedInput, InputLabel, Chip, Link, Table, TableBody, TableRow, TableCell, Tabs, Tab } from '@mui/material'
import { modalStyle, legendStyle, legendIconStyle, legendIconImageStyle, legendTextStyle, modalBoxStyle, modalHeadingStyle, modalFormStyle, checkboxStyle, popupHeaderStyle, chipStyle, chipArrayStyle, popupMainHeadingStyle, popupSecondaryHeadingStyle, popupTertiaryHeadingStyle, tableStyle, tableIconCellStyle, secondaryTableCellStyle, listStyle, listItemHeadingStyle, listItemBodyStyle, messageStyle } from './styles'

function workStudyDatesToString(minStart, minDuration, diplomaDuration) {
  let dates = ''
  const maxStart = diplomaDuration - minDuration + 1
  if (minStart === 1)
    dates += '1re année'
  else
    dates += `${minStart}e année`
  if (minStart !== maxStart)
    dates = `${maxStart}e voire ` + dates
  dates += ' de la formation'
  return dates
}

function internshipDatesToString(minStart, maxStart) {
  let dates = ''
  for (let i = minStart; i <= maxStart; i++) {
    if (i === 1)
      dates += `${i}re`
    else
      dates += `${i}e`
    if (i < maxStart) {
      if (i < maxStart - 1)
        dates += ', '
      else
        dates += ' ou '
    }
    else
      dates += ' année de la formation'
  }
  return dates
}

function internshipPeriodsToString(internshipPeriods, periodsData) {
  let periods = ''
  for (let i = 0; i < internshipPeriods.length; i++) {
    if (i === 0)
      periods += periodsData.get(internshipPeriods[i]).intitule
    else
      periods += periodsData.get(internshipPeriods[i]).intitule.toLowerCase()
    if (i < internshipPeriods.length - 1) {
      if (i < internshipPeriods.length - 2)
        periods += ', '
      else
        periods += ' ou '
    }
  }
  return periods
}

function internshipDurationToString(minDuration, maxDuration) {
  let duration = ''
  if (maxDuration === 1)
    duration += '1 semaine'
  else
    duration += `${maxDuration} semaines`
  if (minDuration !== maxDuration)
    duration = `${minDuration} à ` + duration
  return duration
}

function setMultiSelectParam(input, params, key) {
  for (let i = 0; i < input.length; i++) {
    let param = ''
    if (params.get(key))
      param = params.get(key) + ','
    params.set(key, param + input[i])
  }
}

function MultiSelect({label, input}) {
  return (
    <FormControl sx={modalFormStyle}>
      <InputLabel id={label.id}>{label.value}</InputLabel>
      <Select
        multiple
        value={input.state}
        onChange={(event) => input.updater(event.target.value)}
        renderValue={(selected) => selected.map((id) => input.options.get(id).intitule).join(' ; ')}
        input={<OutlinedInput label={label.value}/>}
        labelId={label.id}
      >
        {[...input.options.keys()].map(id => (
          <MenuItem key={id} value={id}>
            <Checkbox checked={input.state.includes(id)} sx={checkboxStyle}/>
            <ListItemText primary={input.options.get(id).intitule}/>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

function BoolSelect({label, input}) {
  return (
    <FormControl sx={modalFormStyle}>
      <InputLabel id={label.id}>{label.value}</InputLabel>
      <Select
        value={input.state}
        onChange={(event) => input.updater(event.target.value)}
        label={label.value}
        labelId={label.id}
      >
        <MenuItem value=''>&nbsp;</MenuItem>
        <MenuItem value='true'>{input.options.true}</MenuItem>
        <MenuItem value='false'>{input.options.false}</MenuItem>
      </Select>
    </FormControl>
  )
}

function App() {
  const [open, setOpen] = useState(false)
  const [map, setMap] = useState(null)
  const [titres, setTitres] = useState(new Map())
  const [tags, setTags] = useState(new Map())
  const voies = new Map([
    ["FI", {intitule: "Formation initiale"}],
    ["CA", {intitule: "Contrat d'apprentissage"}],
    ["FC", {intitule: "Formation continue"}],
    ["CP", {intitule: "Contrat de professionnalisation"}],
    ["VAE", {intitule: "Validation des acquis de l'expérience"}]
  ])
  const [niveaux, setNiveaux] = useState(new Map())
  const [periodes, setPeriodes] = useState(new Map())
  const [durees, setDurees] = useState(new Map())
  const [sites, setSites] = useState(new Map())
  const [formations, setFormations] = useState([])
  const [params, setParams] = useState(new URLSearchParams())
  const [inputTitre, setInputTitre] = useState([])
  const [inputTag, setInputTag] = useState([])
  const [inputVoie, setInputVoie] = useState([])
  const [inputNiveau, setInputNiveau] = useState([])
  const [inputPeriode, setInputPeriode] = useState([])
  const [inputDuree, setInputDuree] = useState([])
  const [inputPublic, setInputPublic] = useState('')
  const [inputLong, setInputLong] = useState('')
  const [currentTab, setCurrentTab] = useState('voies')

  const changeCurrentTab = (event, newValue) => {
    setCurrentTab(newValue)
  }

  const filter = () => {
    const newParams = new URLSearchParams()
    setMultiSelectParam(inputTitre, newParams, 'diplome__titre__in')
    setMultiSelectParam(inputTag, newParams, 'tags__id__in')
    setMultiSelectParam(inputVoie, newParams, 'voie__type_voie__in')
    setMultiSelectParam(inputNiveau, newParams, 'stage_niveau__in')
    setMultiSelectParam(inputPeriode, newParams, 'stage__depart_possible__id__in')
    setMultiSelectParam(inputDuree, newParams, 'alternance_duree__in')
    if (inputPublic !== '')
      newParams.set('etablissement__public', inputPublic)
    if (inputLong !== '')
      newParams.set('stage_long', inputLong)
    setParams(newParams)
    setOpen(false)
  }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}titres/`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const titresTemp = new Map()
        const niveauxTemp = new Map()
        const dureesTemp = new Map()
        let dureeMax = 1
        data.forEach((titre) => {
          titresTemp.set(titre.id, {abreviation: titre.abreviation, intitule: titre.intitule, duree: titre.duree, icone: L.icon({iconUrl: titre.icone, iconSize: [35, 35]})})
          for (let i = titre.niveau_sortie - titre.duree + 1; i <= titre.niveau_sortie; i++) {
            niveauxTemp.set(i, {intitule: `Bac + ${i}`})
          }
          dureeMax = Math.max(dureeMax, titre.duree)
        })
        setTitres(titresTemp)
        setNiveaux(new Map([...niveauxTemp.entries()].sort((a, b) => a[0] - b[0])))
        dureesTemp.set(1, {intitule: "1 année"})
        for (let i = 2; i <= dureeMax; i++) {
            dureesTemp.set(i, {intitule: `${i} années`})
        }
        setDurees(dureesTemp)
      })
    fetch(`${process.env.REACT_APP_API_URL}tags/`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const temp = new Map()
        data.forEach((tag) => {
          temp.set(tag.id, {intitule: tag.intitule})
        })
        setTags(temp)
      })
    fetch(`${process.env.REACT_APP_API_URL}periodes/`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const temp = new Map()
        data.forEach((periode) => {
          temp.set(periode.id, {intitule: periode.intitule})
        })
        setPeriodes(temp)
      })
    fetch(`${process.env.REACT_APP_API_URL}sites/`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const temp = new Map()
        data.forEach((site) => {
          temp.set(site.id, {intitule: site.intitule, adresse: site.adresse, logo: site.logo})
        })
        setSites(temp)
      })
  }, [])

  useEffect(() => {
    if (map !== null && titres.size > 0 && tags.size > 0 && periodes.size > 0) {
      fetch(`${process.env.REACT_APP_API_URL}formations/?` + params)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          setFormations(data.features)
        })
    }
  }, [map, titres, tags, periodes, params])
  
  useEffect(() => {
    if (map !== null) {
      L.easyButton('<img src="' + filterIcon + '"/>', () => {
        setOpen(true)
      }).addTo(map)
    }
  }, [map])
  
  return (
    <>
    <Modal open={open} onClose={filter} keepMounted>
      <Box sx={modalStyle}>
        <Typography sx={modalHeadingStyle}>Diplôme</Typography>
        <Box sx={modalBoxStyle}>
          <MultiSelect
            label={{ id: 'modal-diploma-type-label', value: 'Type' }}
            input={{ state: inputTitre, updater: setInputTitre, options: titres }}
          />
          <MultiSelect
            label={{ id: 'modal-diploma-domain-label', value: 'Domaine' }}
            input={{ state: inputTag, updater: setInputTag, options: tags }}
          />
          <MultiSelect
            label={{ id: 'modal-diploma-pathway-label', value: 'Voie' }}
            input={{ state: inputVoie, updater: setInputVoie, options: voies }}
          />
        </Box>
        <Typography sx={modalHeadingStyle}>Alternance</Typography>
        <Box sx={modalBoxStyle}>
          <MultiSelect
            label={{ id: 'modal-workstudy-duration-label', value: 'Durée' }}
            input={{ state: inputDuree, updater: setInputDuree, options: durees }}
          />
        </Box>
        <Typography sx={modalHeadingStyle}>Stage</Typography>
        <Box sx={modalBoxStyle}>
          <BoolSelect
            label={{ id: 'modal-internship-type-label', value: 'Type' }}
            input={{ state: inputLong, updater: setInputLong, options: { true: 'Long', false: 'Court' } }}
          />
          <MultiSelect
            label={{ id: 'modal-internship-level-label', value: 'Niveau' }}
            input={{ state: inputNiveau, updater: setInputNiveau, options: niveaux }}
          />
          <MultiSelect
            label={{ id: 'modal-internship-period-label', value: 'Période' }}
            input={{ state: inputPeriode, updater: setInputPeriode, options: periodes }}
          />
        </Box>
        <Typography sx={modalHeadingStyle}>Établissement</Typography>
        <Box sx={modalBoxStyle}>
          <BoolSelect
            label={{ id: 'modal-school-type-label', value: 'Type' }}
            input={{ state: inputPublic, updater: setInputPublic, options: { true: 'Public', false: 'Privé' } }}
          />
        </Box>
      </Box>
    </Modal>
    <MapContainer center={[46.4975, 2.5892]} zoom={6} ref={setMap}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Control position='bottomleft'>
        <List sx={legendStyle}>
          {[...titres.keys()].map(id => (
            <ListItem key={id} disablePadding>
              <ListItemAvatar sx={legendIconStyle}>
                <Avatar src={titres.get(id).icone.options.iconUrl} sx={legendIconImageStyle}/>
              </ListItemAvatar>
              <ListItemText className='shortText' primary={titres.get(id).abreviation} primaryTypographyProps={legendTextStyle}/>
              <ListItemText className='normalText' primary={titres.get(id).intitule} primaryTypographyProps={legendTextStyle} hidden/>
            </ListItem>
          ))}
        </List>
      </Control>
      {sites.size && <Control position='topright'>
        <List sx={legendStyle}>
          {[...sites.keys()].map(id => (
            <ListItem key={id} disablePadding>
              <Link href={sites.get(id).adresse}>
                <img src={sites.get(id).logo} title={sites.get(id).intitule} width='35' alt={sites.get(id).intitule}/>
              </Link>
            </ListItem>
          ))}
        </List>
      </Control>}
      <MarkerClusterGroup>
        {formations.map((formation) => {
          const currentVoies = new Map(formation.properties.voies.map((voie, index) => [voie.type_voie, index]))
          return (
            <Marker key={formation.id} position={[formation.geometry.coordinates[1], formation.geometry.coordinates[0]]} icon={titres.get(formation.properties.titre).icone}>
              <Popup>
                <Box align='center'>
                  <Box sx={popupHeaderStyle}>
                    <Typography sx={popupMainHeadingStyle}>{titres.get(formation.properties.titre).intitule}</Typography>
                    <Typography sx={popupSecondaryHeadingStyle}>{formation.properties.intitule}</Typography>
                    {formation.properties.parcours && <Typography sx={popupTertiaryHeadingStyle}>{formation.properties.parcours}</Typography>}
                  </Box>
                  <Box sx={chipArrayStyle}>
                    {formation.properties.tags.map((id) => (
                      <Chip key={id} size='small' sx={chipStyle} label={tags.get(id).intitule}/>
                    ))}
                  </Box>
                  <Tabs value={currentTab} onChange={changeCurrentTab}>
                    <Tab value='voies' label='Voies'/>
                    <Tab value='stages' label='Stages'/>
                    <Tab value='etablissement' label='Établissement'/>
                  </Tabs>
                  {currentTab === 'voies' && <Table sx={tableStyle} size='small'>
                    <TableBody>
                    {[...voies.keys()].map(id => (
                      <Fragment key={id}>
                        <TableRow>
                          <TableCell variant='head'>{voies.get(id).intitule}</TableCell>
                          <TableCell sx={tableIconCellStyle}><img src={currentVoies.has(id) ? yesIcon : noIcon} width='16' alt={currentVoies.has(id) ? 'Oui' : 'Non'}/></TableCell>
                          <TableCell>{currentVoies.has(id) && formation.properties.voies[currentVoies.get(id)].courriel_responsable && <Chip sx={chipStyle} label='Mail' component='a' href={'mailto:' + formation.properties.voies[currentVoies.get(id)].courriel_responsable} avatar={<Avatar src={emailIcon}/>} clickable/>}</TableCell>
                        </TableRow>
                        {((id === 'CA' || id === 'CP') && currentVoies.has(id)) && <TableRow>
                          <TableCell colSpan={3} sx={secondaryTableCellStyle}>
                            <List sx={listStyle} dense>
                              <ListItem>
                                <ListItemText primary='Début' secondary={workStudyDatesToString(formation.properties.voies[currentVoies.get(id)].debut_au_plus_tot, formation.properties.voies[currentVoies.get(id)].duree_minimale, titres.get(formation.properties.titre).duree)} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                              </ListItem>
                              {formation.properties.voies[currentVoies.get(id)].rythme && <ListItem>
                                <ListItemText primary='Rythme' secondary={formation.properties.voies[currentVoies.get(id)].rythme} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                              </ListItem>}
                            </List>
                          </TableCell>
                        </TableRow>}
                      </Fragment>
                    ))}
                    </TableBody>
                  </Table>}
                  {currentTab === 'stages' &&
                    <>
                    {formation.properties.stages.length > 0
                      ? <Table sx={tableStyle} size='small'>
                          <TableBody>
                          {formation.properties.stages.map((stage) => (
                            <>
                              <TableRow>
                                <TableCell variant='head'>{stage.obligatoire ? 'Stage obligatoire' : 'Stage facultatif'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={secondaryTableCellStyle}>
                                  <List sx={listStyle} dense>
                                    <ListItem>
                                      <ListItemText primary='Année' secondary={internshipDatesToString(stage.debut_au_plus_tot, stage.debut_au_plus_tard)} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                                    </ListItem>
                                    <ListItem>
                                      <ListItemText primary='Période' secondary={internshipPeriodsToString(stage.depart_possible, periodes)} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                                    </ListItem>
                                    <ListItem>
                                      <ListItemText primary='Durée' secondary={internshipDurationToString(stage.duree_minimale, stage.duree_maximale)} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                                    </ListItem>
                                    {stage.precision && <ListItem>
                                      <ListItemText primary='Remarque' secondary={stage.precision} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                                    </ListItem>}
                                  </List>
                                </TableCell>
                              </TableRow>
                            </>
                          ))}
                          </TableBody>
                        </Table>
                      : <Typography sx={messageStyle}>Aucun stage n'a été renseigné&hellip;</Typography>
                    }
                    </>
                  }
                  {currentTab === 'etablissement' && <Table sx={tableStyle} size='small'>
                    <TableBody>
                      <TableRow>
                        <TableCell variant='head'>Nom</TableCell>
                        <TableCell>{formation.properties.etablissement}</TableCell>
                      </TableRow>
                      {formation.properties.universite && <TableRow>
                        <TableCell variant='head'>Université</TableCell>
                        <TableCell>{formation.properties.universite}</TableCell>
                      </TableRow>}
                      <TableRow>
                        <TableCell variant='head'>Type</TableCell>
                        <TableCell>Établissement {formation.properties.public ? 'public' : 'privé'}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell variant='head'>Adresse</TableCell>
                        <TableCell>{formation.properties.adresse}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell variant='head'>Code postal</TableCell>
                        <TableCell>{formation.properties.code_postal}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell variant='head'>Commune</TableCell>
                        <TableCell>{formation.properties.commune}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell variant='head'>Département</TableCell>
                        <TableCell>{formation.properties.departement}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell variant='head'>Académie</TableCell>
                        <TableCell>{formation.properties.academie}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell variant='head'>Région</TableCell>
                        <TableCell>{formation.properties.region}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>}
                  <List sx={listStyle} dense>
                    <ListItem>
                      <ListItemText primary='Prérequis' secondary={formation.properties.pre_requis} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                    </ListItem>
                    {formation.properties.capacite && <ListItem>
                      <ListItemText primary="Capacité d'accueil" secondary={formation.properties.capacite} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                    </ListItem>}
                    {formation.properties.etablissement_co_accredite && <ListItem>
                      <ListItemText primary='Établissement co-accrédité' secondary={formation.properties.etablissement_co_accredite} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                    </ListItem>}
                    <ListItem>
                      <ListItemText primary='Admission' secondary={formation.properties.recrutement} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                    </ListItem>
                    {formation.properties.remarque && <ListItem>
                      <ListItemText primary='Remarque' secondary={formation.properties.remarque} primaryTypographyProps={listItemHeadingStyle} secondaryTypographyProps={listItemBodyStyle}/>
                    </ListItem>}
                  </List>
                  <Chip sx={chipStyle} label='Page web' component='a' href={formation.properties.page_web} avatar={<Avatar src={internetIcon}/>} clickable/>
                </Box>
              </Popup>
            </Marker>
          )
        })}
      </MarkerClusterGroup>
    </MapContainer>
    </>
  );
}

export default App;